export const visit = (vm, at) => {
at({ "en": { "theme": { "legacy": "Legacy", "canvas": "Default", "round": "Round", "sharp": "Sharp", "linear": "Linear" } } });
};